import axios from 'axios';
import authHeader from './auth-header';

const NODE_ENV = process.env.NODE_ENV;
const PROTOCOL = process.env.PROTOCOL || 'http://';
const END_POINT_URL = process.env.END_POINT_URL || window.location.hostname;
const END_POINT_PORT = process.env.END_POINT_PORT || '8080';

const API_URL = NODE_ENV === 'production' ? PROTOCOL + END_POINT_URL + '/api/scouting-analysis/' : PROTOCOL + END_POINT_URL + ':' + END_POINT_PORT + '/api/scouting-analysis/';

class ScoutingAnalysisService {

  createPlayerScoutingAnalysis(analysis) {
    return axios.post(`${API_URL}player`, analysis);
  };

  getPlayerScoutingAnalysis() {
    return axios.get(`${API_URL}players`);
  };

  getPlayerScoutingAnalysisByPlayerId(playerId) {
    return axios.get(`${API_URL}player/${playerId}`, playerId);
  };

  deletePlayerScoutingAnalysis(analysisId) {
    return axios.delete(`${API_URL}player/${analysisId}`, analysisId);
  };

  getPlayerFinalRatingAvg(playerId) {
    return axios.get(`${API_URL}player/${playerId}/avg-final-rating`);
  };

  getPlayerPotentialAvg(playerId) {
    return axios.get(`${API_URL}player/${playerId}/avg-potential`);
  };

  getPlayerOverallScoreAvg(playerId) {
    return axios.get(`${API_URL}player/${playerId}/avg-overall-score`);
  };

  updatePlayerScoutingAnalysis(analysis) {
    return axios.put(`${API_URL}player`, analysis);
  };

  getPlayerScoutingAnalysisByTaskIds(taskIds) {
    return axios.get(`${API_URL}player/from-task/${taskIds}`, taskIds);
  };

  getGameScoutingAnalysisByGameId(gameId) {
    return axios.get(`${API_URL}game/${gameId}`, gameId);
  };

  createGameScoutingAnalysis(analysis) {
    return axios.post(`${API_URL}game`, analysis);
  };

  updateGameScoutingAnalysis(analysis) {
    return axios.put(`${API_URL}game`, analysis);
  };

  deleteGameScoutingAnalysis(analysisId) {
    return axios.delete(`${API_URL}game/${analysisId}`, analysisId);
  };

  getGameScoutingAnalysisByTaskIds(taskIds) {
    return axios.get(`${API_URL}game/from-task/${taskIds}`, taskIds);
  };

  getGameScoutingAnalyses() {
    return axios.get(`${API_URL}games`);
  };

  getTagsOfAUserByScout() {
    return axios.get(`${API_URL}tags`);
  }
}

export default new ScoutingAnalysisService();